import {
  CarrierT,
  CustomOrderT,
  EquipmentTypeT,
  LocationT,
  OfferSourceT,
  OrderT,
} from "../../../../../domain";
import { boolean, number, object, string } from "yup";

type StepsT = "offer-form" | "summary";

type OfferFormT = Partial<{
  carrier: CarrierT;
  order: Partial<OrderT>;
  truckLocation: LocationT;
  emptyTruck: boolean;
  comments: string;
  rate: number;
  commission: number;
  origin_zip_code: number;
  destination_zip_code: number;
  offerSource: OfferSourceT;
}>;

type DataT = Partial<{
  carrier: CarrierT;
  order: OrderT;
  customOrder: CustomOrderT;
  type: "single" | "dedicated";
  rate: number;
  commission: number;
  comments: string;
  shipperLocation: LocationT;
  receiverLocation: LocationT;
  distance: number;
  from: string;
  equipmentType: EquipmentTypeT;
  truckLocation: LocationT;
  emptyTruck: boolean;
}>;

type GeneralStepProps = {
  setStep: (value: StepsT) => void;
};

const NewEntryFormSchema = object().shape({
  carrier: object().required("Carrier is required").nullable(),
  order: object().required("Order is required").nullable(),
  truckLocation: object().required("Truck Location is required").nullable(),
  emptyTruck: boolean(),
  comments: string().nullable(),
  rate: number()
    .typeError("Must be a number")
    .required("Rate is required")
    .positive("Must be positive")
    .max(99999, "Too high"),
  commission: number(),
  origin_zip_code: number()
    .typeError("Must be a number")
    .required("This is required")
    .positive("Must be positive")
    .max(99999, "Too high")
    .nullable(),
  destination_zip_code: number()
    .typeError("Must be a number")
    .required("This is required")
    .positive("Must be positive")
    .max(99999, "Too high")
    .nullable(),
});

export type { DataT, StepsT, GeneralStepProps, OfferFormT };
export { NewEntryFormSchema };
